import React, {
  useState,
  useEffect,
  createContext,
  lazy,
  Suspense,
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Redirect,
  Route,
  Link,
  Navigate,
  useNavigate,
  useParams,
} from "react-router-dom";
import LayoutHome from "./web/layout/LayoutHome";
import MyaccountLayout from "./web/layout/MyaccountLayout";
import Notfound from "./web/layout/Notfound";
import Forgotpassword from "./web/Forgotpassword";
import Signin from "./web/Signin";
import Signup from "./web/Signup";
import Homeinfo from "./web/Homeinfo";
//import Home  from './web/Home';
import Market from "./web/Market";
import Myaccount from "./web/Myaccount";
import Fund from "./web/Fund";
import Deposit from "./web/Fund/Deposit";
import Help from "./web/Help";
import Download from "./web/Download";
import Contact from "./web/Contact";
import Terms from "./web/pages/Terms";
import Privacypolicy from "./web/pages/Privacypolicy";
import Profile from "./web/Myaccount/Profile";
import Management from "./web/Myaccount/Management";
import Payment from "./web/Myaccount/Payment";
import Kyc from "./web/Myaccount/Kyc";
import Activity from "./web/Myaccount/Activity";
import Withdraw from "./web/Myaccount/Withdraw";
//import Signin  from './web/Signin';
import {
  updateSession,
  loaderBar,
  apibaseURl,
  currencySymbol,
  errorToast,
  successToast,
  loggedInCustomerDetails,
} from "./functions/Function";
const WebContext = createContext();
//const Home = lazy(() => import('./web/Home'));

const Home = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./web/Home")), 3000);
  });
});
const Webroute = (props) => {
  let getwebUserloggedIn = JSON.parse(localStorage.getItem("customer"));
  const [webUserloggedIn, setWebUserloggedIn] = useState(getwebUserloggedIn);
  const [wallet, setWallet] = useState(0.00);
  const [portfolioAmt, setPortfolioAmt] = useState(0.00);
  const [totalAmount, setTotalAmount] = useState(0.00);
  const [customer, setcustomer] = useState({});

  const customerInAdmin = () => {
    let getuserloggedIn = JSON.parse(localStorage.getItem("customer"));
    if (getuserloggedIn) {
      setWebUserloggedIn(getuserloggedIn);
      getLoggedInUserDetails();
    } else {
      setWebUserloggedIn(null);
    }
  };

  const customerLogout = () => {
    localStorage.removeItem("customer");
    let getwebUserloggedIn = JSON.parse(localStorage.getItem("customer"));
    setWebUserloggedIn(null);
    setcustomer({});
  };

  const Webprotected = ({ children }) => {
    let getuserloggedIn = JSON.parse(localStorage.getItem("customer"));
    if (getuserloggedIn != null) {
      return <Navigate to="/home" replace />;
    }
    return children;
  };

  const Privateprotected = ({ children }) => {
    let getuserloggedIn = JSON.parse(localStorage.getItem("customer"));
    if (getuserloggedIn == null) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  const fetchWallet = () => {
    fetch(apibaseURl + "wallet/" + loggedInCustomerDetails("id"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: loggedInCustomerDetails("id"),
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.result == true) {
          setWallet(result.response.wallet);
          setPortfolioAmt(result.response.portfolio);
          setTotalAmount(result.response.total);
        }
      });
  };

  const getLoggedInUserDetails = () => {
    fetch(apibaseURl + "user/"+ loggedInCustomerDetails("id"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: loggedInCustomerDetails("id"),
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status == true) {
          console.log(result.response)
          setcustomer(result.response)
          updateSession("is_approved", result.response.is_approved);
        }
      });
  };

  let WebContextdata = {
    fetchWallet: fetchWallet,
    wallet: wallet,
    portfolioAmt: portfolioAmt,
    totalAmount: totalAmount,
    customerLogout: customerLogout,
    customer: customer,
    updateUser: getLoggedInUserDetails,
  };

  useEffect(() => {
    getLoggedInUserDetails();
    fetchWallet();
  }, []);

  return (
    <WebContext.Provider value={WebContextdata}>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <LayoutHome
              isloggedIn={webUserloggedIn != null ? true : false}
              customerLogout={customerLogout} customer={customer}
            />
          }
        >
          <Route
            exact
            path="/"
            element={
              <Webprotected>
                <Homeinfo />
              </Webprotected>
            }
          />

          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/download" element={<Download />} />
          <Route exact path="/help" element={<Help />} />
          <Route exact path="/terms-and-conditions" element={<Terms />} />
          <Route exact path="/privacy-policy" element={<Privacypolicy />} />
          </Route>

        <Route
          exact
          path="/login"
          element={
            <Webprotected>
              <Signin customerInAdmin={customerInAdmin}  />
            </Webprotected>
          }
        />
        <Route
          exact
          path="signup"
          element={
            <Webprotected>
              <Signup />
            </Webprotected>
          }
        />

        <Route
          exact
          path="forgotpassword"
          element={
            <Webprotected>
              <Forgotpassword />
            </Webprotected>
          }
        />

        <Route
          exact
          path="/home"
          element={
            <Privateprotected>
              <LayoutHome isloggedIn={true} customerLogout={customerLogout} customer={customer} />
            </Privateprotected>
          }
        >
          <Route
            exact
            path="/home"
            element={
              <React.Suspense fallback={loaderBar(500)}>
                <Home customer={customer} />
              </React.Suspense>
            }
          />

              <Route
                exact
                path="/home/my-account"
                element={
                  <Privateprotected>
                    <MyaccountLayout  isloggedIn={true}   customerLogout={customerLogout} customer={customer} />
                  </Privateprotected>
                }
              >
                <Route index element={<Navigate to="profile" replace />} />
                <Route exact path="profile" element={<Profile />} />
                <Route exact path="/home/my-account/management" element={<Management />} />
                <Route exact path="/home/my-account/payment" element={<Payment />} />
                <Route exact path="/home/my-account/kyc" element={<Kyc />} />
                <Route exact path="/home/my-account/activity" element={<Activity />} />
                <Route exact path="/home/my-account/withdraw" element={<Withdraw />} />
              </Route>


          <Route exact path="/home/market" element={<Market />} />
          {/* <Route exact path="/home/my-account" element={<Myaccount  customer={customer} />} /> */}
          <Route exact path="/home/fund" element={<Fund />} />
          <Route exact path="/home/deposit" element={<Deposit />} />
          <Route exact path="*" element={<Notfound />} />
        </Route>
      </Routes>
    </WebContext.Provider>
  );
};

export default Webroute;
export { WebContext };
